export default __webpack_public_path__ + "static/media/amertrad3.942ab385.png";